import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/info-filled-blue.svg';
import themeColors from '../../../assets/styles/themeColors';
import BottomDrawer from '../../Drawer/Drawer';
import SfhSecondaryButton from './SfhSecondaryButton';

const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0;
`;

const DrawerIconWrapper = styled.div`
  margin-bottom: 16px;
`;

const DrawerDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${themeColors.colorTextSecondary};
  text-align: center;
  line-height: 1.5;
`;

const PhoneLink = styled.a`
  color: ${themeColors.colorPrimary};
  text-decoration: underline;
`;

const DrawerFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  > button {
    width: 100%;
  }
`;

const NonUsSellFromHomeDrawer = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const footer = (
    <DrawerFooter>
      <SfhSecondaryButton onClick={onClose} data-cy="button-sfh-non-us-close">
        {t('common.close')}
      </SfhSecondaryButton>
    </DrawerFooter>
  );

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      footer={footer}
      maxHeight="70%"
    >
      <DrawerContent>
        <DrawerIconWrapper>
          <InfoIcon width={48} height={48} />
        </DrawerIconWrapper>
        <DrawerDescription>
          {t('portfolio.sellFromHome.nonUs.title')}
        </DrawerDescription>
        <DrawerDescription>
          <PhoneLink
            href={`tel:${t('portfolio.sellFromHome.nonUs.phoneNumber')}`}
          >
            {t('portfolio.sellFromHome.nonUs.needHelp')}{' '}
            {t('portfolio.sellFromHome.nonUs.phone')}
          </PhoneLink>
        </DrawerDescription>
      </DrawerContent>
    </BottomDrawer>
  );
};

NonUsSellFromHomeDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default NonUsSellFromHomeDrawer;
